import { StoresSpreadsheet } from '../../../spreadsheets/stores-spreadsheet';
import api from '../../api';
import environment from '../../environment';
import layers from '../../layers';
import { loading, unloading } from '../../shared';
import translate from '../tools/translate';
import Dialog from './Dialog';
import dialogBox from '../dialog';
import moment from 'moment';
import _ from "lodash";
import { ContextEnum } from '../../../enuns/context.enum';
import { StoreTypeEnum } from '../../../enuns/store.enun';
import { ConsultTypeEnum } from '../../../enuns/consultType.enum';
import { FeaturePermission } from '../../../constants/feature.permission.helper';

const LayerControls = (name) => require('../../controls').get(name);
const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

let typeParameter;
const groupProp = 'Grupo';
const brandProp = 'Bandeira';
const vmmProp = 'MediaMensal';
const totalSalesProp = 'TotalVendas';
const nameProp = 'Nome';

class Stores extends Dialog {
    constructor(area, _type = null) {
        api.general.log.action(ContextEnum.SelectTool, 'Camada de Lojas');
        typeParameter = _type;

        const contexts: {label: string, context: string, mainLabel: boolean}[] = [
            {label: translate('Common.Competitors'), context: 'Competitors', mainLayer: true},
            {label: environment.get('CONFIG.CLIENT'), context: 'Dealerships'},
        ];

        const labelTitleProp = typeParameter === 'directSales' ? 'DirectSales' : 'Retail';
        const labelTitle = ` - ${translate(`Common.${labelTitleProp}`)}`;

        super(translate('Common.Stores'), area, contexts, labelTitle);
        this.rangePicking = true;
        this.saveAsExcel = this.saveAsExcel.bind(this);
        this.getChartConfig = this.getChartConfig.bind(this);
    }

    populateLayers () {
        this.preventMultipleCalls();
        this._features = [];
        const {dealerships, competitors} = api.store.get.all;
        const getEnv = prop => environment.get(prop);
        const filterPeriod = (this: any).filterPeriod;
        const parameterIsDirectSales = typeParameter === 'directSales';

        const contexts = [
            {
                context: 'Dealerships',
                authorization: 'stores',
                api: () => dealerships(getEnv(`CONFIG.DEALERS`), getEnv('CONFIG.FILTERS.CLIENT_TYPES')),
            },
            {
                context: 'Competitors',
                authorization: 'competitors',
                api: () => competitors(getEnv(`CONFIG.COMPETITORS`), ConsultTypeEnum.AllStoreType),
                hide: parameterIsDirectSales
            },
        ];

        const queue = contexts
            .filter(({context}) => environment.get('FEATURES')[context])
            .map(({context, authorization, api}) => {
                const layer = layers.get(context);

                return api()
                  .then(fc => {
                    layer.setFeatures(fc);
                    return LayerControls(context).addSalesProperty(layer.toGeoJSON(), parameterIsDirectSales, filterPeriod);
                  })
                  .then(fc => {
                    layer.setFeatures(fc);
                    this.addToLayers(layer);
                  });
            });

        return Promise.all(queue).then(() => this.enablePopulateLayers());
    }

    get calculateTotals(){
       return _.size((this: any)._features);
    }

    saveAsExcel (e) {
        const canShowGroupClient = environment.get('CONFIG.FILTERS.HAS_GROUP_CLIENT') && isAuthorized(FeaturePermission.MAP.toolShowGroupClient);
        e.preventDefault();
        loading();

        setTimeout(() => {
          const filterPeriod = (this: any).filterPeriod;
          const {start, end} = filterPeriod;
          const getYearMonth = (date: Date) => Number(moment(date).format('YYYYMM'));
          const parameterIsDirectSales = typeParameter === 'directSales';

          const data = {
            ids: this.featuresProperties.map(x => x.IdOriginal),
            anoMesInicio: getYearMonth(start),
            anoMesFim: getYearMonth(end),
            idSegments: [],
            type: parameterIsDirectSales,
            showGroupClient: canShowGroupClient
          };

          api.store.get.sales.download(data).then(result => {
            unloading();
          });
        }, 300);
    }

    createDropdownOptions () {
        return [groupProp, brandProp, vmmProp, totalSalesProp]
        .filter(x => this.featuresProperties.some(z => !!z[x]))
        .map(val => ({ text: translate(`Common.${val}`), value: val }));
    }

    shouldSumByAverage () {
        return vmmProp === this._type.value();
    }

    shouldSumByTotal () {
        return totalSalesProp === this._type.value();
    }

    aggregateBy (property) {
        const countFeatures = (final, obj) => {
            final[obj[property]] = (final[obj[property]] || 0) + 1;
            return final;
        };

        const aggregateFeatures = (final, obj) => {
            const prop = `${obj[brandProp]} - ${obj[nameProp]}`;
            final[prop] = (final[prop] || 0) + obj[property];
            return final;
        };

        const funcReducer = property === vmmProp || property === totalSalesProp ? aggregateFeatures: countFeatures;

        return this.featuresProperties.reduce(funcReducer, {});
    }

    handleChangePeriod(){
        const {valueForDatePicker, changePeriod} = LayerControls(context);

        dialogBox.datepicker(valueForDatePicker, {}, (text, value) => {
          api.general.log.action(ContextEnum.SelectTool, 'Mudou Filtro', JSON.stringify(value));
          return changePeriod(value);
        });
    }
}

export default Stores;



// WEBPACK FOOTER //
// ./src/scripts/core/selection/Stores.js